import basicController from "servicestack/basic.controller.properties";
import templateUrl from "emun.swatch/swatch-lists.htm";
import config from "emun.swatch/swatch.config";
import modals from "webmodals/modals";
import AutoQuery from "servicestack/auto-query/auto-query";
import SwatchListPrompt from "emun.swatch/swatchlist-prompt";

export class SwatchListsController {
  constructor() {
    const $ctrl = this;
    basicController($ctrl);
    $ctrl.query = new AutoQuery(config.listAutoQueryOptions);
    $ctrl.query.criteria.listType = $ctrl.listType || "swatch";
    $ctrl.bus = $ctrl.query.bus;
    $ctrl.selectAll = false;
  }
  create() {
    const $ctrl = this;
    SwatchListPrompt.open({ model: {listType: $ctrl.query.criteria.listType} }).then(() => $ctrl.query.load());
  }
  view(list) {
    const $ctrl = this;
    $ctrl.$state.transitionTo("swatch.editlist", { listId: list.id });
  }
  $onInit() {
    const $ctrl = this;
  }
  load() {
    return this.query.load();
  }

  delete(m) {
    let $ctrl = this;
    return modals
      .confirm("Are you sure?", "Delete List")
      .result.then(function () {
        return $ctrl.bus.send("DeleteSwatchList", m).then(function (response) {
          $ctrl.query.load(true);
        });
      });
  }
}

export default {
  bindings: {
    listType: "@"
  },
  controller: SwatchListsController,
  templateUrl($element, $attrs) {
    return $attrs.templateUrl || templateUrl;
  },
};
